import React from "react";
import { translate, setLanguage } from 'react-multi-lang'

class Agreement extends React.Component {


  state = {
    about: {
      fb_share_number: 39128,
      twitter_share_number: 13121,
      google_share_number: 2930,
      about_us: `
      <html lang="zh-CN"><head><meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1">
        <title>关于用户使用app隐私协议</title>
        <meta name="description" content="">
      </head><body>
        <h1>关于用户使用app隐私协议</h1>
      <p>在此特别提醒您（用户）在注册成为用户之前，请认真阅读本关于用户使用app隐私协议（以下简称“本协议”），确保您充分理解本协议中各条款。请您审慎阅读并选择接受或不接受本协议。除非您接受本协议所有条款，否则您无权注册、登录或使用本协议所涉服务。您的注册、登录、使用等行为将被视为对本协议的接受，并同意接受本协议各项条款的约束。</p>
      <p>本协议约定亞美卫视（以下简称本公司）与用户之间关于AATTV（以下简称本APP）软件（IOS/安卓系统开放注册及使用 ）服务（以下简称“服务”）的权利义务。“用户”是指注册、登录、使用本APP服务的个人或相关使用者。本协议可由本APP软件系统运行后台及本公司随时更新，更新后的协议条款一旦公布即代替原来的协议条款，恕不再另行通知，用户可在本APP中查阅最新版协议条款，也提请用户随时关注本APP用户协议的更新情况，以免造成不必要的误解和纠纷。在修改协议条款后，如果用户不接受修改后的条款，请立即停止使用本APP提供的服务，用户继续使用本APP提供的服务将被视为接受修改后的协议。</p>
      <h2>一、用户账号注册基本要求</h2>
      <p>1、用户在使用本服务前不需要注册个人账号。</p>
      <h2>二、用户个人隐私信息保护</h2>
      <p>1、如果本APP运行后台及本公司发现或收到他人举报或投诉用户违反本协议约定的，本公司有权在收到举报后24小时内不经通知随时对相关内容，包括但不限于用户资料、上传及发贴记录进行审查、删除，并视情节轻重对违规账号处以包括但不限于警告、账号封禁 、设备封禁、功能封禁等处罚，且不必通知用户处理结果。</p>
      <p>2、因违反用户协议被封禁的用户，可以自行与本APP后台或本公司公开的方式进行联系。其中，被实施功能封禁的用户会在封禁期届满后自动恢复被封禁功能。被封禁用户可提交申诉，本APP后台或本公司将对申诉进行审查，并自行合理判断决定是否变更处罚措施。</p>
      <p>3、用户理解并同意，本APP后台及本公司有权依合理判断对违反有关法律法规或本协议规定的行为进行处罚，对违法违规的任何用户采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，用户应承担由此而产生的一切法律责任。</p>
      <p>4、用户理解并同意，因用户违反本协议约定，导致或产生的任何第三方主张的任何索赔、要求或损失，包括合理的律师费，用户应当对本公司与合作公司、关联公司等相关方的赔偿，并使之免受损害。</p>
      <p>5、用户体验改进，我们可能会收集经过MD5算法和加密的国际移动设备身份码（IMEI）和网络设备地址（MAC）,广告标识符IDFA，系统版本号，设备型号，系统编号，系统ID号，操作系统版本号，屏幕分辨率，上网模式，本款产品的版本号信息，某个按钮的点击使用时间及频率，某些关键配置选项值，软件崩溃日志等，用于统计我们的产品数量、分析产品使用情况、版本升级判断、排查崩溃原因、减少崩溃等情况，以此不断改善我们的产品。这些信息不涉及到您个人身份等隐私信息。</p>
      <h2>三、用户使用内容规范</h2>
      <p>1、本条所述用户使用内容是指用户使用本APP的过程中所制作、上载、复制、发布、传播的任何内容，包括但不限于账号头像、名称、用户说明等注册信息及认证资料，或文字（包括艺术字）、符号、标识、语音、图片、（自定义）照片、视频（包括用户自行制作或上传的短视频等）、图文、模型、形象及其相互组合的内容等上传、发送、回复或自动回复消息和相关链接页面，以及其他使用本账号或本APP服务所产生的内容。</p>  
      <p>2、用户不得利用本账号或本APP服务制作、上载、复制、发布、传播如下法律、法规和政策禁止的内容：</p>
      <ul>
      <li>(1) 违反宪法所确定的基本原则的；</li>
      <li>(2) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</li>
      <li>(3) 损害国家荣誉和利益的；</li>
      <li>(4) 煽动民族仇恨、民族歧视，破坏民族团结的；</li>
      <li>(5) 破坏国家宗教政策，宣扬邪教和封建迷信的；</li>
      <li>(6) 散布谣言，扰乱社会秩序，破坏社会稳定的；</li>
      <li>(7) 诱导未成年人违法犯罪和散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</li>
      <li>(8) 侮辱或者诽谤他人，侵害他人合法权益的；</li>
      <li>(9) 危害社会公德，损害民族优秀文化传统的；</li>
      <li>(10)非法的广播电视频道、视听节目网站提供的非法视频内容；</li>
      <li>(11)有关法律、行政法规和国家规定禁止的其他内容。</li>
      </ul>
      <p>3、用户不得利用本账号或本APP服务制作、上载、复制、发布、传播如下干扰本APP正常运营，以及侵犯其他用户或第三方合法权益的内容：</p>
      <ul>
      <li>(1) 含有任何性或性暗示的；</li>
      <li>(2) 含有辱骂、恐吓、威胁内容的；</li>
      <li>(3) 含有骚扰、垃圾广告、恶意信息、诱骗信息的；</li>
      <li>(4) 涉及他人隐私、个人信息或资料的；</li>
      <li>(5) 侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的；</li>
      <li>(6) 含有其他干扰本APP服务正常运营和侵犯其他用户或第三方合法权益内容的信息。</li>
      </ul>
      <p>4、用户不得对本服务任何部分或本服务之使用或获得，进行复制、拷贝、出售、转售或用于任何其它商业目的。</p>
      <p>5、用户须对自己在使用本APP服务过程中的行为承担法律责任。用户承担法律责任的形式包括但不限于：对受到侵害者进行赔偿，以及在本公司首先承担了因其用户行为导致的行政处罚或侵权损害赔偿的法律责任后，用户应给予本公司等额的赔偿，以及本公司因此而受到的其他损失等。</p>
      <h2>四、用户使用APP规则</h2>
      <p>1、用户在使用本APP服务中或通过本APP所传送、发布的任何内容并不反映或代表，也不得被视为反映或代表本APP所属公司（以下简称本公司）的观点、立场或政策，本公司对此不承担任何责任。</p>
      <p>2、用户不得利用本账号或本APP服务进行如下行为：</p>
      <ul>
      <li>(1) 提交、发布虚假信息，或盗用他人头像或资料，冒充、利用他人名义的；</li>
      <li>(2) 强制、诱导其他用户关注、点击链接页面或分享信息的；</li>
      <li>(3) 虚构事实、隐瞒真相以误导、欺骗他人的；</li>
      <li>(4) 利用技术手段批量建立虚假账号的；</li>
      <li>(5) 利用本账号或本APP服务从事任何违法犯罪活动的；</li>
      <li>(6) 制作、发布与以上行为相关的方法、工具，或对此类方法、工具进行运营或传播，无论这些行为是否为商业目的；</li>
      <li>(7) 其他违反法律法规规定、侵犯其他用户合法权益、干扰本APP及其所属公司正常运营或本APP未明示授权的行为。</li>
      </ul>
      <p>3、用户须对利用本账号或本APP服务传送信息的真实性、合法性、无害性、准确性、有效性等全权负责，与用户所传播的信息相关的任何法律责任由用户自行承担，与本APP及本公司无关。如因此给本APP及本公司或任何第三方造成损害的，用户应当依法予以赔偿，本公司亦将保留追究相关用户及使用人的法律、经济等全部责任。</p>
      <p>4、本公司提供的本APP服务中可能包括广告，用户同意在使用过程中显示本公司和第三方供应商、合作伙伴提供的广告。除法律法规明确规定外，用户应自行对依该广告信息进行的交易负责，对用户因依该广告信息进行的交易或前述广告商提供的内容而遭受的损失或损害，本公司不承担任何责任。</p>
      <h2>五、知识产权及其他合法权益保护声明</h2>
      <p>1 、本APP上传及使用功能专为用户自己创作或享有合法来源的作品提供服务。本APP及本公司尊重他人知识产权和合法权益，请用户在上传相关内容前确保拥有上传内容的著作权及信息网络传播权或者已经取得上述全部权利人的许可。</p>
      <p>2 、对于用户上传到本APP上及使用本APP服务过程中，用户同意本APP及本公司在全世界范围内具有免费的、永久性的、不可撤销的、非独家的和完全再许可的权利和许可，以使用、复制、修改、改编、出版、翻译、据以创作衍生作品、传播、表演和展示此等内容（整体或部分），和/或将此等内容编入当前已知的或以后开发的其他任何形式的作品、媒体或技术中。</p>
      <p>3 、用户应确保上传的相关内容，已经获得被拍摄人（如有）的许可，并确保作品内容没有侵犯他人的人身权，包括但不限于名誉权、肖像权、隐私权、姓名权，不存在任何著作权纠纷。</p>
      <h2>六、服务风险声明</h2>
      <p>1、用户完全理解并同意，本APP服务涉及到互联网及移动通讯等服务，可能会受到各个环节不稳定因素的影响。因此服务存在因上述不可抗力、计算机病毒或黑客攻击、系统不稳定、用户所在位置、用户关机、GSM网络、互联网络、通信线路原因等造成的服务中断或不能满足用户要求的风险。使用本服务的用户须承担以上风险，本公司对服务之及时性、安全性、准确性不作担保，对因此导致用户不能发送和接受消息、或传递错误，个人设定之时效、未予储存或其他问题不承担任何责任。对于不可抗力或非本APP及本公司过错原因导致的用户数据损失、丢失或服务停止，本APP及本公司将不承担任何责任。</p>
      <p>2、对于系统发生故障影响到本APP服务的正常运行，本公司承诺会及时处理并尽可能进行修复。但用户因此而产生的经济和精神损失，本公司不承担任何责任。此外，本APP保留不经事先通知为优化、升级或其他目的暂停本APP服务任何部分或全部的权利。</p>
      <p>3、本APP及本公司郑重提请您注意，任何经由本APP服务以上载的相关内容，均由账号所有者承担责任。本公司无法控制经由本APP服务上载之内容，也无法对用户的使用行为进行全面控制，因此不保证内容的合法性、正确性、完整性、真实性或品质；您已预知使用本APP服务时，可能会接触到令人不快、不适当或令人厌恶之内容，并同意将自行加以判断并承担所有风险，而不依赖于本APP及本公司。但在任何情况下，本APP及本公司有权依法停止传输任何前述内容并采取相应行动，包括但不限于暂停用户使用本APP服务的全部或部分功能，保存有关记录，并向有关机关报告。本APP后台及本公司有权(但无义务)依其自行之考量，拒绝和删除可经由本APP服务提供之违反本条款的或其他引起本APP或其他用户反感的任何内容。</p>
      <p>4、用户完全理解并同意，若第三方在您不知情或未经您同意的前提下，将您的作品上传于本APP上及由此所产生的任何可能侵害您权益的行为，本APP及本公司均不对任何人承担任何责任。 </p>
      <p>5、用户完全理解并同意，第三方可以通过访问本APP上的相关信息，并可对信息进行使用行为。对用户或第三方以任何方式进行的使用可能侵害您权益的行为，本APP及本公司均不对任何人承担任何责任。</p>
      <p>6、用户完全理解并同意，在发现用户使用APP过程中出现的任何有争议的内容或用户本身存在任何争议性，本公司及本APP坚决零容忍，并承诺一经发现，严肃处理，包括但不限于删除用户发布的内容、封禁或注销用户个人账户以及向有关部门提供其账户及个人信息等。对此，本公司及本APP拥有自主识别相关争议内容和争议用户的决定权，用户一旦使用本APP视为无条件接受本条款的约束和规定。</p>
      <h2>七、其他提示</h2>
      <p>1、本公司郑重提醒用户注意本协议中免除本APP及本公司责任和限制用户权利的条款，请用户仔细阅读，自主考虑及辨别相关风险。未成年人应在法定监护人的陪同下阅读本协议及使用本APP服务。</p>
      <p>2、本协议的效力、解释及纠纷的解决，适用于中华人民共和国法律。若用户和本APP及本公司之间发生任何纠纷或争议，首先应友好协商解决，协商不成的，用户同意将纠纷或争议提交本公司住所地有管辖权的人民法院管辖。&nbsp;本公司有权启动必要的刑事及民事法律程序，维护本公司的合法权益，追究违法用户的法律责任。</p>
      <p>3、本协议的任何条款无论因何种原因无效或不具有可执行性，其余条款仍有效，对双方具有约束力。</p>
      <p>4、本APP软件及本公司未行使或执行本服务协议任何权利或规定，不构成对前述权利或其他权利之放弃。</p>
      <p>5、本协议未尽事宜，以本APP运行后台及本公司后续不定期更新或补充本协议相关内容为准，更新及补充条款与本协议不可分割。</p>
      <p>6、本协议相关条款的最终解释权归本公司所有。</p>
      </body></html>`
    }
  }

  render() {
    return (
      <div>
        <div class="wrap wrap_gray">
          <div class="container">
            <div class="row">
              <div class="row">
                    <p class="current__text no-padding-left" dangerouslySetInnerHTML={{ __html: this.state.about.about_us }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default translate(Agreement);
